import { useSyncExternalStore } from 'react';

const cache = new Map<string, MediaQueryList>();

function lista(query: string): MediaQueryList {
  let mql = cache.get(query);
  if (!mql) {
    mql = window.matchMedia(query);
    cache.set(query, mql);
  }
  return mql;
}

/** Faixas da Secao 6.9. `useSyncExternalStore` evita repintura extra no resize. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mql = lista(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    () => lista(query).matches,
    () => false,
  );
}
